import api from 'api';
import ApiService from 'api/ApiService';
import {DialogResult, DialogTypes} from 'common/names';
import {castToSend} from 'common/yup/castToSend';
import {layoutActions, layoutTypes} from 'features/layout/redux';
import i18n from 'i18n';
import {call, put, SagaReturnType, take} from 'redux-saga/effects';
import {asyncSagaConstructor, unhandedSagaError} from 'redux/common';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {ITransaction, Transaction} from 'types/diplomat/transaction/Transaction';
import types from '../types';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

function* openConfirmDialog() {
   yield put(
      layoutActions.openSubDialog({
         id: DialogTypes.ConfirmationDialog.id,
         title: i18n.t('Save Transaction Confirmation'),
         content: i18n.t(`Save transaction?`),
      })
   );
   const result: ICloseSubDialogAction<string> = yield take(layoutTypes.CLOSE_SUB_DIALOG);
   return result?.payload?.result === DialogResult.OK;
}

export function* sendTransactionSaga(act: {
   type: string;
   payload: {data: ITransaction; helpers?: FormOnSubmitHelpers<ITransaction>};
}) {
   try {
      const {data, helpers} = act.payload;
      const isOk = (yield call(openConfirmDialog)) as SagaReturnType<typeof openConfirmDialog>;
      if (isOk) {
         const postSaga = (yield call(
            asyncSagaConstructor,
            data.id ? api.transactionsUpdate : api.transactions,
            types.SEND_TRANSACTION,
            {
               getMethod: ApiService.postSecureJson,
               data: {
                  transactionType:
                     data.objectType === DiplomatObjectType.enum.INBOUND_TRANSACTION
                        ? 'Inbound'
                        : 'Outbound',
                  transactionName: data.name,
                  overwrite: !!data.id,
                  ...castToSend(Transaction, data, {
                     stripUnknown: true,
                  }),
               },
            }
         )) as SagaReturnType<typeof asyncSagaConstructor>;
         const resp = (yield call(postSaga)) as SagaReturnType<typeof postSaga>;

         return resp;
      }
   } catch (e) {
      yield call(unhandedSagaError, e as Error);
   }
}
